// KORRIGIERTE Firmendaten - immoriya Unternehmensgruppe

export const companies = {
  holding: {
    id: "immoriya",
    name: "immoriya Projektentwicklung GmbH",
    shortName: "immoriya",
    tagline: "Die Holding – Immobilienwerte in Osnabrück",
    description: "immoriya Projektentwicklung GmbH ist die Muttergesellschaft und strategische Holding der Unternehmensgruppe.",
    address: {
      street: "Dammstraße 2",
      zip: "49084",
      city: "Osnabrück",
      country: "Deutschland"
    },
    contact: {
      phone: "+49 172 560 66 23",
      email: "mariya@immoriya.de",
      whatsapp: "+491725606623"
    },
    legal: {
      ceo: "Mariya Düselder",
      registerCourt: "Amtsgericht Osnabrück",
      registerNumber: "HRB 213031",
      ustId: "DE321256963",
      steuernummer: "66/200/67526"
    },
    operations: [
      "Strategische Holding-Führung"
    ],
    color: "#3B82F6"
  },

  energiya: {
    id: "energiya",
    name: "Energiya GmbH",
    ownership: "100% Tochter",
    tagline: "Energetische Sanierung & Modernisierung",
    description: "Energiya ist spezialisiert auf energetische Sanierungen, Modernisierung und hochwertigen Ausbau für Dritte. Besuchen Sie auch energiya.immoriya.de für weitere Informationen.",
    subdomain: "https://energiya.immoriya.de",
    logo: "https://customer-assets.emergentagent.com/job_57d8a4c9-6e2f-4e0d-8762-b72128e24d27/artifacts/zwtq035c_75AF297F-D30A-4058-BB93-66F311721A70.png",
    address: {
      street: "Pagenstecherstraße 65 A",
      zip: "49090",
      city: "Osnabrück",
      country: "Deutschland"
    },
    contact: {
      phone: "+49 172 560 66 23",
      email: "energiya@immoriya.de",
      whatsapp: "+491725606623"
    },
    legal: {
      ceo: "Mariya Düselder",
      registerCourt: "Amtsgericht Osnabrück",
      registerNumber: "HRB 222340",
      ustId: "DE321256963",
      steuernummer: "66/200/77343"
    },
    services: [
      "Energetische Sanierung",
      "Wärmepumpen-Installation",
      "Dämmung & Fassade",
      "Dachausbau & Innenausbau",
      "Photovoltaik",
      "KfW-Förderberatung"
    ],
    heroImage: "https://images.unsplash.com/photo-1636163232015-7be35ebf9be7?w=1200",
    color: "#10B981"
  },

  mynah: {
    id: "mynah",
    name: "MYNAH GmbH",
    ownership: "51% Beteiligung",
    tagline: "Immobilienhandel & Fix & Flip",
    description: "MYNAH fokussiert sich auf Immobilienhandel, Fix & Flip Projekte und Zwangsversteigerungen mit Wertsteigerungspotenzial.",
    logo: "https://customer-assets.emergentagent.com/job_57d8a4c9-6e2f-4e0d-8762-b72128e24d27/artifacts/rny8g9d2_IMG_1679.png",
    address: {
      street: "Pagenstecherstraße 65 A",
      zip: "49090",
      city: "Osnabrück",
      country: "Deutschland"
    },
    contact: {
      phone: "+49 172 560 66 23",
      email: "mynah@immoriya.de",
      whatsapp: "+491725606623"
    },
    legal: {
      ceo: "Mariya Düselder",
      registerCourt: "Amtsgericht Osnabrück",
      registerNumber: "HRB 219390",
      ustId: "DE321256963",
      steuernummer: "66/200/77394"
    },
    services: [
      "Immobilienankauf",
      "Fix & Flip Projekte",
      "Zwangsversteigerungs-Objekte",
      "Objektbewertung",
      "Projektentwicklung",
      "Neubau-Projektierung",
      "Investorenbetreuung"
    ],
    color: "#F59E0B"
  },

  mk: {
    id: "mk",
    name: "MK Immobilienverwaltung GmbH",
    ownership: "100% Tochter",
    tagline: "Verwaltung eigener Immobilien",
    description: "Die MK Immobilienverwaltung GmbH verwaltet ausschließlich die eigenen Wohn- und Gewerbeimmobilien der Unternehmensgruppe. Zusätzlich bieten wir Kurzzeitvermietung und Monteurunterkünfte für Firmenkunden an.",
    logo: "https://customer-assets.emergentagent.com/job_57d8a4c9-6e2f-4e0d-8762-b72128e24d27/artifacts/ljhiiqp6_IMG_1678.png",
    address: {
      street: "Darumer Straße 16B",
      zip: "49086",
      city: "Osnabrück",
      country: "Deutschland"
    },
    contact: {
      phone: "+49 172 560 66 23",
      email: "buchung@mkimmobilienverwaltung.de",
      whatsapp: "+491725606623"
    },
    legal: {
      ceo: "Mariya Düselder",
      registerCourt: "Amtsgericht Osnabrück",
      registerNumber: "HRB 215214",
      ustId: "DE321256963",
      steuernummer: "66/200/38585"
    },
    services: [
      "Verwaltung eigener Wohnimmobilien",
      "Verwaltung eigener Gewerbeimmobilien",
      "Kurzzeitvermietung",
      "Monteurunterkünfte für Firmenkunden",
      "Instandhaltung eigener Bestände"
    ],
    color: "#8B5CF6"
  }
};

// Hero Slides mit hochgeladenen Bildern
export const heroSlides = [
  {
    image: "https://customer-assets.emergentagent.com/job_gruppe-osnabrueck/artifacts/tyz0xdgq_ich.jpeg",
    title: "Mariya Düselder",
    subtitle: "Geschäftsführerin",
    description: "Mit unternehmerischem Weitblick schaffen wir nachhaltige Immobilienwerte in Osnabrück."
  },
  {
    image: "https://customer-assets.emergentagent.com/job_gruppe-osnabrueck/artifacts/sfx7w575_ich2.jpeg",
    title: "Persönliche Betreuung",
    subtitle: "Auf Geschäftsführungsebene",
    description: "Direkte Kommunikation und schnelle Entscheidungen – ohne lange Abstimmungswege."
  },
  {
    image: "https://customer-assets.emergentagent.com/job_gruppe-osnabrueck/artifacts/22g2bs60_ich3.jpeg",
    title: "Lokal verwurzelt",
    subtitle: "Osnabrück",
    description: "Wir kennen den Markt, die Stadtteile und die Entwicklungen vor Ort."
  },
  {
    image: "https://customer-assets.emergentagent.com/job_gruppe-osnabrueck/artifacts/l2kix40a_ich4.jpeg",
    title: "Vertrauensvolle Zusammenarbeit",
    subtitle: "Transparenz & Ehrlichkeit",
    description: "Immobilien sind Vertrauenssache. Wir setzen auf offene Kommunikation."
  }
];

// Projekt-Platzhalter mit realistischen deutschen Immobilien
export const projectPlaceholders = [
  {
    title: "Mehrfamilienhaus Osnabrück",
    type: "Wohnimmobilie",
    image: "https://customer-assets.emergentagent.com/job_57d8a4c9-6e2f-4e0d-8762-b72128e24d27/artifacts/mnfa39pv_IMG_1682.png",
    description: "Hochwertige Wohneinheiten"
  },
  {
    title: "Klinkergebäude",
    type: "Mehrfamilienhaus",
    image: "https://customer-assets.emergentagent.com/job_57d8a4c9-6e2f-4e0d-8762-b72128e24d27/artifacts/7o6oz2u7_IMG_1683.png",
    description: "Gepflegte Wohnanlage"
  },
  {
    title: "Modernisierte Wohnung",
    type: "Wohneinheit",
    image: "https://images.unsplash.com/photo-1648475233136-e291e7bed05a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBiYXRocm9vbSUyMHJlbm92YXRpb24lMjBjbGVhbiUyMG1pbmltYWx8ZW58MHx8fHwxNzc1MzA2NzA0fDA&ixlib=rb-4.1.0&q=85",
    description: "Clean renoviertes Bad"
  },
  {
    title: "Einfamilienhaus",
    type: "Wohnimmobilie",
    image: "https://customer-assets.emergentagent.com/job_57d8a4c9-6e2f-4e0d-8762-b72128e24d27/artifacts/u8t9d57i_IMG_1681.png",
    description: "Solide Bausubstanz"
  },
  {
    title: "Renovierte Einheit",
    type: "Wohnung",
    image: "https://images.unsplash.com/photo-1631048499052-e6d9f305d2c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBiYXRocm9vbSUyMHJlbm92YXRpb24lMjBjbGVhbiUyMG1pbmltYWx8ZW58MHx8fHwxNzc1MzA2NzA0fDA&ixlib=rb-4.1.0&q=85",
    description: "Moderne Ausstattung"
  },
  {
    title: "Stadtimmobilie",
    type: "Mehrfamilienhaus",
    image: "https://customer-assets.emergentagent.com/job_57d8a4c9-6e2f-4e0d-8762-b72128e24d27/artifacts/rpzj994m_IMG_1750.jpeg",
    description: "Zentrale Lage"
  }
];
